import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import BenefitsGrid from '../BenefitsGrid';
import { Benefit } from '../BenefitsGrid/BenefitsGrid';
import Overlay from '../Overlay';
import styles from './benefitsPopup.module.css';
import BenefitsPopupHeader from './BenefitsPopupHeader';
import { benefitsPopupId } from './config';

export interface BenefitsPopupProps extends WithTestId {
  benefits: Benefit[];
  title: string;
}

const BenefitsPopup = ({
  benefits,
  title,
  dataTestIdPrefix,
}: BenefitsPopupProps) => (
  <div
    className={styles.benefitsPopupContainer}
    id={benefitsPopupId}
    data-testid={toKebabCase(dataTestIdPrefix, 'benefitsPopup')}
  >
    <Overlay />
    <div className={styles.benefitsPopup}>
      <BenefitsPopupHeader title={title} dataTestIdPrefix={dataTestIdPrefix} />
      <BenefitsGrid benefits={benefits} dataTestIdPrefix={dataTestIdPrefix} />
    </div>
  </div>
);
export default BenefitsPopup;
